<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1><span style="font-size:19pt;">A</span>bout the <span style="font-size:19pt;">A</span>uthor</h1>
<p>Michael Simpson is married to Ellen and lives in Cambridgeshire with his children, Evelyn, Rory and Max. He only started writing during lockdown and <em>The</em> <em>Devil’s Ferryman</em> is his debut novel.</p><br/>
<p style="text-indent:00em;">Michael has been a secondary school teacher for over sixteen years and he teaches physical education, history and sociology.</p><br/>
<p style="text-indent:00em;">In his spare time, Michael enjoys keeping fit, playing football and spending time with his family.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?dca6f9a4